import * as yup from 'yup'

import type { ObjectShape } from 'yup/lib/object'

export type SchemaConfig = {
  id: string | number
  type: string
  validationType: string
  validations: {
    type: string
    params: unknown[]
  }[]
}

export function createYupSchema(schema: ObjectShape, config: SchemaConfig) {
  const { id, validationType, validations = [] } = config

  // Checkboxes with a required validation need to make sure they are set to true
  if (validationType === 'boolean' && validations.some((validation) => validation.type === 'required')) {
    validations.push({
      type: 'oneOf',
      params: [[true], 'Dit veld is verplicht'],
    })
  }
  //@ts-expect-error this is hard to type
  if (!yup[validationType]) {
    return schema
  }
  //@ts-expect-error this is hard to type
  let validator = yup[validationType]()
  validations.forEach((validation) => {
    const { params, type } = validation
    if (!validator[type]) {
      return
    }
    validator = validator[type](...params)
  })
  schema[id] = validator
  return schema
}
